import { TaxonomyIdItem } from "@amzn/taxonomy-lib";
import { createTrackClickInteraction } from "common/helpers/track-click-interaction";
import { AIForMeTool } from "lib/models/aiforme-models";
import { CatalogicalService } from "lib/services";
import { CSRFService } from "lib/services/csrf-service";
import { useMemo } from "react";

/**
 * Hook that provides a stable click interaction tracker function.
 * Centralizes the wiring of CatalogicalService and CSRFService
 *
 * @returns A memoized function to track click interactions
 *
 * @example
 * ```tsx
 * const trackClickInteraction = useTrackClickInteraction();
 *
 * <AiForMeItem onTrackClick={trackClickInteraction} />
 * ```
 */
export function useTrackClickInteraction(): (taxonomyId: TaxonomyIdItem) => void {
  const client = useMemo(() => new CatalogicalService<AIForMeTool>("aiforme"), []);
  const csrfService = useMemo(() => new CSRFService(), []);

  return useMemo(() => createTrackClickInteraction(client, csrfService), [client, csrfService]);
}
